<template>
    <div>
        <!-- Los avisos (toast) salen con el cartel de las notificaciones del
             sitio (NotificacionesToasts, vía avisar()): mismo diseño en todos lados. -->

        <!-- Modal genérico -->
        <div v-if="modal" class="ee-modal" @keydown.esc="cerrarModal">
            <div class="ee-modal-backdrop" @click="cerrarModal"></div>
            <div ref="card" :class="['ee-modal-card', { 'ee-modal-card--wide': modal.ancho }]" role="dialog" aria-modal="true" aria-labelledby="ee-modal-t" tabindex="-1">
                <button type="button" class="ee-modal-x" :aria-label="$t('editor_espacio.close')" @click="cerrarModal">×</button>
                <slot :name="modal.nombre" />
            </div>
        </div>
    </div>
</template>

<script>
import { avisar, quitarAviso } from '@/Utils/notificaciones';

export default {
    name: 'EeCapas',
    data() { return { modal: null, volver: null }; },
    created() { this.conAccion = []; },
    methods: {
        /** toast(texto, 'ok'|'error'|'info', { label, fn }) — misma firma de siempre. */
        toast(msg, tipo = 'ok', accion = null) {
            const id = avisar({ tipo, titulo: msg, accion: accion ? { label: accion.label, fn: accion.fn } : null, duracion: accion ? 9000 : 4500 });
            if (accion) this.conAccion.push(id);
            return id;
        },
        // Los avisos con acción (Deshacer, Reintentar…) dependen de esta pantalla: se quitan al salir.
        limpiar() { this.conAccion.forEach(quitarAviso); this.conAccion = []; },

        abrirModal(nombre, { ancho = false } = {}) {
            this.volver = document.activeElement;
            this.modal = { nombre, ancho };
            document.documentElement.classList.add('ee-no-scroll');
            this.$nextTick(() => {
                const c = this.$refs.card;
                if (!c) return;
                (c.querySelector('[autofocus]') || c.querySelector('input, button:not(.ee-modal-x)') || c).focus();
            });
        },
        cerrarModal() {
            if (!this.modal) return;
            this.modal = null;
            document.documentElement.classList.remove('ee-no-scroll');
            if (this.volver && this.volver.focus) this.volver.focus();
        },
    },
    beforeDestroy() {
        this.limpiar();
        document.documentElement.classList.remove('ee-no-scroll');
    },
};
</script>
